import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ChoiceXatSvc } from 'net-api-lib';
import { map, shareReplay } from 'rxjs';
import { AmountChoice } from './models';

@Injectable({
  providedIn: 'root',
})
export class ChoicesService {
  private choiceXatSvc = inject(ChoiceXatSvc);

  amountChoices$ = this.choiceXatSvc.getAmountTypes().pipe(
    map(r =>
      (r.content ?? []).map(
        choice =>
          ({
            label: choice.shorthand!,
            value: +choice.code!,
            choice,
          }) as AmountChoice
      )
    ),
    shareReplay(1)
  );

  amountChoices = toSignal(this.amountChoices$);
}
